import type { TeamSummary } from '@mockd/shared';
import { InlineEdit } from '../common';

interface TeamGeneralSettingsProps {
  team: TeamSummary;
  canEdit: boolean;
  onRename: (name: string) => Promise<void>;
}

export function TeamGeneralSettings({ team, canEdit, onRename }: TeamGeneralSettingsProps) {
  return (
    <div className="card bg-base-100">
      <div className="card-body">
        <h2 className="card-title text-lg">General</h2>
        <div className="space-y-3 mt-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-base-content/70">Name</span>
            {canEdit ? (
              <InlineEdit type="text" value={team.name} onSave={onRename} label="Team name" />
            ) : (
              <span className="text-sm font-medium">{team.name}</span>
            )}
          </div>
          <div className="divider my-0" />
          <div className="flex justify-between items-center">
            <span className="text-sm text-base-content/70">Slug</span>
            <span className="text-sm font-mono text-base-content/60">{team.slug}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
